import React, { useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext, API } from '@/App';
import { toast } from 'sonner';

export default function AuthCallback() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const hash = window.location.hash;
    const sessionMatch = hash.match(/session_id=([^&]+)/);
    if (!sessionMatch) {
      navigate('/auth');
      return;
    }
    const sessionId = sessionMatch[1];
    const pendingRole = sessionStorage.getItem('pending_google_role') || 'tenant';

    axios.post(`${API}/auth/google`, { session_id: sessionId, role: pendingRole })
      .then((response) => {
        const { access_token, user } = response.data;
        login(access_token, user);
        sessionStorage.removeItem('pending_google_role');
        toast.success(`Welcome, ${user.name}!`);
        // Clear hash and navigate
        window.history.replaceState(null, '', window.location.pathname);
        if (user.role === 'landlord') navigate('/landlord/dashboard');
        else if (user.role === 'admin') navigate('/admin/dashboard');
        else navigate('/tenant/dashboard');
      })
      .catch((error) => {
        toast.error(error.response?.data?.detail || 'Google sign-in failed');
        navigate('/auth');
      });
  }, [login, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground">Signing you in with Google...</p>
      </div>
    </div>
  );
}
